import { array, arrayOf, func, node, number, shape, string } from 'prop-types';
import React from 'react';
import { components } from 'react-select';

import MultiValueGroup from './MultiValueGroup';

const SelectValueContainer = components.ValueContainer;

function renderMultiValuesWithUpdatedLabel(props, childNodes, inputElement) {
  return (
    <SelectValueContainer {...props}>
      {childNodes.slice(0, -1).map(multiValueChild => {
        const { data } = multiValueChild.props;
        if (!data) return multiValueChild; // placeholder
        return React.cloneElement(multiValueChild, {}, data.selectLabel);
      })}
      {inputElement}
    </SelectValueContainer>
  );
}

function ValueContainer(props) {
  const { aggregateSelection, onGroupSelect, value } = props.selectProps;
  const childNodes = React.Children.toArray(props.children);
  const inputElement = childNodes.slice(-1);

  if (value.length < 6) {
    return renderMultiValuesWithUpdatedLabel(props, childNodes, inputElement);
  }

  return (
    <SelectValueContainer {...props}>
      {aggregateSelection
        .filter(group => group.selected > 0)
        .map(group => (
          <MultiValueGroup
            key={group.label}
            {...group}
            onClear={() => {
              onGroupSelect(group.label, false);
            }}
          />
        ))}
      {inputElement}
    </SelectValueContainer>
  );
}
ValueContainer.propTypes = {
  children: node.isRequired,
  selectProps: shape({
    onGroupSelect: func.isRequired,
    value: array, // eslint-disable-line react/forbid-prop-types
    aggregateSelection: arrayOf(
      shape({
        label: string.isRequired,
        selected: number.isRequired,
        options: number.isRequired,
      }),
    ),
  }).isRequired,
};

export default ValueContainer;
